import React, {useEffect} from 'react';
import {Outlet, useLocation, useNavigate} from "react-router-dom";
import {FormattedMessage} from "react-intl";

import './MyPicksView.style.scss';
const MyPicksTab = Object.freeze({
    ONGOING: 'ongoing',
    LAST_THIRTY_DAYS: 'lastthirtydays',
    ALL_TIME: 'alltime',
});

const MyPicksView = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [currentTabSelected, setCurrentTabSelected] = React.useState('');

    useEffect(() => {
        const path = location.pathname.split('/').pop();
        setCurrentTabSelected(path);
    }, [location]);

    const handleNavigation = (path) => {
        navigate(`/myaccount/mypicks/${path}`);
    }

    return (
        <div className="MyPicksView">
            <div className="myPicksTitle gold-gradient-text"><FormattedMessage id={"myAccountView.myPicks.title"}/> </div>
            <div className="buttonGroup">
                <button
                    className={`pickButton ${currentTabSelected === MyPicksTab.ONGOING ? "active" : ""}`}
                    onClick={() => handleNavigation(MyPicksTab.ONGOING)}
                >
                    <FormattedMessage id={"myAccountView.myPicks.onGoing"}/>
                </button>
                <button
                    className={`pickButton ${currentTabSelected === MyPicksTab.LAST_THIRTY_DAYS ? "active" : ""}`}
                    onClick={() => handleNavigation(MyPicksTab.LAST_THIRTY_DAYS)}
                >
                    <FormattedMessage id={"myAccountView.myPicks.last30Days"}/>
                </button>
                <button
                    className={`pickButton ${currentTabSelected === MyPicksTab.ALL_TIME ? "active" : ""}`}
                    onClick={() => handleNavigation(MyPicksTab.ALL_TIME)}
                >
                    <FormattedMessage id={"myAccountView.myPicks.allTime"}/>
                </button>
            </div>
            <Outlet/>
        </div>
    );
}

export default MyPicksView;